// The payload is the deleted role's id, wrapped in an object: synapse's `DefaultPayload` requires
// `payload` to be a record (or an array of records), never a bare primitive.
export type RoleDeletedPayload = {
	roleId: number;
};

export type RoleDeletedAction = {
	type: 'ROLE_DELETED';
	payload: RoleDeletedPayload;
	accountId: number;
};

export default (payload: RoleDeletedPayload, accountId: number): RoleDeletedAction => ({
	type: 'ROLE_DELETED',
	payload,
	accountId,
});
